<template>
  <div class="text-center pa-4">
    <v-dialog :model-value="dialogOpen" max-width="400" persistent
              @update:modelValue="$emit('update:dialogOpen', $event)">
      <v-card prepend-icon="mdi-alert">
        <v-card-title>{{ title }}</v-card-title>
        <v-card-text>{{ text }}</v-card-text>

        <template v-slot:actions>
          <v-spacer></v-spacer>

          <v-btn @click="$emit('update:dialogOpen', false); $emit('cancel')">
            <v-icon color="red" icon="mdi-cancel" start></v-icon>
            {{ cancelText }}
          </v-btn>

          <v-btn @click="$emit('confirm')">
            <v-icon color="green" icon="mdi-checkbox-marked-circle" start></v-icon>
            {{ confirmText }}
          </v-btn>

        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>

const props = defineProps({
  title: String,
  text: String,
  confirmText: String,
  cancelText: String,
  dialogOpen: Boolean
});

defineEmits(['update:dialogOpen', 'confirm', 'cancel']);

</script>